import React, { useState } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { useMutation, useQuery } from 'components/graphql'
import ContentBlock from 'components/ContentBlock'
import { Form, Text, Select } from 'components/forms'
import { ServiceModal } from 'components/Modal'
import Button from 'components/Button'
import Divider from 'components/Divider'
import { getContentLanguageLabel } from 'components/ContentTranslations'

import availableLocales from './availableLocales'
import { listContentTranslationLanguages, createLanguageMutation } from './gql'

const StyledModalContainer = styled.div`
	text-align: justify;
`

const ContentTranslations = () => {
	const [showModal, setShowModal] = useState(false)
	const [newLanguage, setNewLanguage] = useState('')
	const languagesRes = useQuery(listContentTranslationLanguages)
	const [t] = useTranslation()
	// const [updateLanguage] = useMutation(updateLanguageMutation)
	const [createLanguage] = useMutation(createLanguageMutation)
	const languageData = languagesRes.data?.listContentTranslationLanguages?.items
	const languageLocales = languageData?.map(({ locale }) => locale) || []

	const countryList = availableLocales.map(locale => ({
		value: locale,
		label: getContentLanguageLabel(locale)
	}))

	const handleCreate = () => {
		createLanguage({
			variables: { locale: newLanguage.value },
			refetchQueries: [{ query: listContentTranslationLanguages }]
		})
	}

	return(
		<ContentBlock isLoading={languagesRes.loading}>
			<Form
				smartSubmit
				initialValues={{
					languages: languageData?.map(({ id, locale }) =>
						countryList.find(item => item.value === locale)?.label
					)
				}}
				// onSubmit={handleUpdate}
			>
				<Row>
					<Col xs>
						{languagesRes.data?.listContentTranslationLanguages?.items?.map((item, i) =>
							<Text readOnly label={i === 0 ? t('options_section.fields.translationLanguages') : null} field={`languages[${i}]`}/>
						)}
					</Col>
				</Row>
				<Divider height={20}/>
				<Col type='row'>
					<Button type='button' status='primary' onClick={() => setShowModal(true)} text={t('common.buttons.create')}/>
				</Col>
			</Form>
			{showModal &&
				<ServiceModal
					onClose={() => setShowModal(false)}
					label={t('common.buttons.confirm')}
					btnText={t('common.buttons.confirm')}
					btnCancelText={t('common.buttons.cancel')}
					text={t('options_section.strings.newTranslationLanguageConfirmation')}
					width={340}
					onOk={() => {
						handleCreate()
						setShowModal(false)
					}}
				>
					<StyledModalContainer>
						<Select
							noForm
							label={t('options_section.fields.newLanguage')}
							options={countryList.filter(({ value }) => !languageLocales.includes(value))}
							onChange={opt => setNewLanguage(opt)}
							isSearchable
						/>
						<Divider height={500}/>
					</StyledModalContainer>
				</ServiceModal>
			}
		</ContentBlock>
	)
}

export default ContentTranslations
